
import { mapGetters } from 'vuex'
import { hashObject, filenameToFAName } from '@/util/string'

export default {
    data () {
        return {
            total: 0,
            size: 10,
            page: 1,
            pages: 1,
            messages: [],
            message: '',
            loadingMessage: false,
            REC_START: /\n/g,
            REC_STOP: /\n/g,
            recognition: null,
            isRecording: false,
            selectedPlanIds: [],
            uploadedFiles: [],
            uploadingFiles: null,
            uploadingMetadata: {}
        }
    },
    fetch () {
        // this.autopopulateStatus()
        return this.loadMessages()
    },
    computed: {
        ...mapGetters([
            'year',
            'survey',
            'client',
            'plansMap',
            'quotesInSight',
            'getCurrentContext',
        ]),
    },
    watch: {
        // Watch for changes in the lists to reapply defaults if the lists change
        'client.id' () {
            this.loadMessages()
        }
    },
    mounted () {
        if ('webkitSpeechRecognition' in window) {
            // eslint-disable-next-line new-cap
            this.recognition = new window.webkitSpeechRecognition()
            this.recognition.continuous = false
            this.recognition.interimResults = false
            this.recognition.lang = 'en-US'

            this.recognition.onresult = (event) => {
                const transcript = event.results[0][0].transcript
                this.message = this.message + transcript
                this.isRecording = false
            }

            this.recognition.onerror = (event) => {
                console.error('Speech recognition error:', event.error)
                this.isRecording = false
            }

            this.recognition.onend = () => {
                this.isRecording = false
            }
        }
    },
    methods: {
        filenameToFAName,
        removeUploadedFileById (file) {
            const idx = this.uploadedFiles.findIndex(f => f.id === file.id)
            if (idx > -1) {
                this.uploadedFiles.splice(idx, 1)
            }
        },
        removeUploadingFileByIndex (idx) {
            this.uploadingFiles.splice(idx, 1)
        },
        async uploadFiles (files) {
            if (!files || !files.length) {
                return
            }
            const form = new FormData()
            files.forEach((f, i) => {
                form.append('files', f)
            })
            const results = await this.$try('roseAiUploadChatFiles', form, { ...this.uploadingMetadata, uid: this.client?.id, })
            if (!results.error) {
                (results?.files || []).forEach((file) => {
                    if (file.file_id) {
                        this.uploadedFiles.push(file)
                    }
                })
                this.uploadingFiles = null
            }
        },
        async sendMessage () {
            const message = this.message
            if (!message || message.trim() === '') {
                return this.$store.commit('pushAlert', { message: 'Please enter a message before sending.' })
            }

            const files = this.uploadedFiles.map(f => ({ id: f.file_id, name: f.file_name, type: f.file_type }))
            this.messages.push({
                content: message,
                role: 'user',
                files,
                plan_ids: this.selectedPlanIds,
                created: new Date().toLocaleString(),
            })
            this.total += 1
            this.matchScroll()
            this.message = ''
            this.loadingMessage = true

            const currentContext = this.getCurrentContext()

            const response = await this.$try(
                'roseAiSendChatMessage', {
                    uid: this.client?.id,
                    content: message,
                    metadata: {
                        page_context: this.selectedPlanIds?.length ? '' : this.$jsonSafeStringify(currentContext.pageContext || {}),
                    },
                    files,
                    plan_ids: this.selectedPlanIds || [],
                    plan_year: this.year
                }, { spinner: false })

            this.loadingMessage = false
            if (!response.error) {
                const chatMessage = response.message
                chatMessage.hash = hashObject(chatMessage)
                this.messages.push({ ...chatMessage, created: new Date().toLocaleString() })
                this.total += 1
                this.matchScroll()
            }
        },
        matchScroll () {
            this.$nextTick(() => {
                const messageDisplay = this.$refs?.chatArea
                if (!messageDisplay) return
                messageDisplay.scrollTop = messageDisplay.scrollHeight
            })
        },
        async loadMessages ({ page = 1, size = this.size } = {}) {
            const response = await this.$try('roseAiGetChatMessages', this.client?.id, { page, size }, { spinner: false })
            this.page = response?.page
            this.pages = response?.pages
            this.total = response?.total
            this.messages = (response?.items || []).concat(this.messages || [])
            if (page === 1) {
                this.matchScroll()
            }
        },
        clearMessages () {
            this.messages = []
            this.uploadedFiles = []
            this.total = this.messages.length
            return this.$try('roseAiClearChatMessages', this.client?.id)
        },
        async autopopulateStatus () {
            const result = await this.$try('getNlRecStatus', this.survey.id)
            if (!result.error) {
                this.message = `Can you recommend a medicare plan for me? ${result.nl_rec_status}\n`
            }
        },
        toggleSpeechRecognition () {
            if (!this.recognition) {
                return this.$store.commit('pushAlert', { message: 'Speech recognition is not supported in your browser.' })
            }
            if (this.isRecording) {
                this.recognition.stop()
                this.isRecording = false
            } else {
                this.recognition.start()
                this.isRecording = true
            }
        },
        clearMessage () {
            this.message = ''
        },
        clearMessageAndPlansAndFiles () {
            this.message = ''
            this.uploadedFiles = []
            this.selectedPlanIds = []
        },
        togglePlanSelection (planId) {
            const index = this.selectedPlanIds.indexOf(planId)
            if (index > -1) {
                // Remove from selection
                this.selectedPlanIds.splice(index, 1)
            } else {
                // Add to selection
                this.selectedPlanIds.push(planId)
            }
        },
    },
}
